<template>
  <div>
    <el-dialog
      title="住宿明细"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
      :close-on-click-modal="false"
      append-to-body
      modal-append-to-body
      :destroy-on-close="true"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="120px" label-position="right">
        <el-row v-if="userType">
          <el-col :span="12">
            <el-form-item label="所属项目编号" prop="ssxmCode">
              <el-input
                v-model="form.ssxmCode"
                placeholder="请选择项目"
                :disabled="readonly"
                @focus="showProjectDialog"
                style="cursor: pointer"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="showProjectDialog"
                ></el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属项目名称" prop="ssxmName">
              <el-input v-model="form.ssxmName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="开始日期" prop="startDate">
              <el-date-picker
                v-model="form.startDate"
                type="date"
                placeholder="选择开始日期"
                style="width: 100%"
                value-format="yyyy-MM-dd"
                :disabled="readonly"
                @change="chengeDate"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束日期" prop="endDate">
              <el-date-picker
                v-model="form.endDate"
                type="date"
                placeholder="选择结束日期"
                style="width: 100%"
                value-format="yyyy-MM-dd"
                :disabled="readonly"
                @change="chengeDate"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="住宿城市" prop="city">
              <el-input
                v-model="form.city"
                placeholder="请输入住宿城市"
                :disabled="readonly"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="住宿天数" prop="zsTs">
              <jh-number
                :decimalNumber="0"
                placeholder="请输入住宿天数"
                v-model="form.zsTs"
                @change="handleZsTsChange"
                :disabled="readonly"
              >
                <span slot="append">天</span>
              </jh-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="住宿金额" prop="zsAmt">
              <jh-number
                :decimalNumber="2"
                placeholder="请输入住宿金额"
                :isMoney="true"
                v-model="form.zsAmt"
                @change="handleZsAmtChange"
                :disabled="readonly"
              >
                <span slot="append">元</span>
              </jh-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单价" prop="zsPrice">
              <jh-number
                :decimalNumber="2"
                placeholder="请输入单价"
                :isMoney="true"
                v-model="form.zsPrice"
                @change="handleZsPriceChange"
                :disabled="readonly"
              >
                <span slot="append">元</span>
              </jh-number>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 添加发票信息显示区域 -->
        <el-row>
          <el-col :span="24">
            <el-divider content-position="left">发票信息</el-divider>
            <div style="width: 100%; overflow-x: auto">
              <el-table :data="form.fpList || []" style="width: 100%" size="small" border>
                <el-table-column prop="fpNumber" label="发票号码" min-width="150"></el-table-column>
                <el-table-column
                  prop="fpTypeName"
                  label="发票类型"
                  min-width="120"
                ></el-table-column>
                <el-table-column
                  prop="fpCatName"
                  label="发票种类"
                  min-width="120"
                ></el-table-column>
                <el-table-column prop="kpDate" label="开票日期" min-width="120">
                  <template slot-scope="scope">
                    {{ formatKpDate(scope.row.kpDate) }}
                  </template>
                </el-table-column>
                <el-table-column prop="fpAmt" label="金额" min-width="120" align="right">
                  <template slot-scope="scope"> {{ scope.row.fpAmt }}元 </template>
                </el-table-column>
                <el-table-column prop="fpRemark" label="备注" min-width="150"> </el-table-column>
                <el-table-column label="操作" min-width="120" align="center" fixed="right">
                  <template slot-scope="scope">
                    <el-button type="text" @click="previewInvoice(scope.row)"> 预览 </el-button>
                    <el-button
                      v-if="!readonly"
                      type="text"
                      style="color: #f56c6c"
                      @click="removeInvoice(scope.$index)"
                    >
                      删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ readonly ? '关 闭' : '取 消' }}</el-button>
        <el-button type="primary" @click="showInvoiceDialog" v-if="!readonly">选择发票</el-button>
        <el-button
          v-if="form.fpList && form.fpList.length > 0"
          type="success"
          @click="previewAllInvoices"
          >查看全部发票</el-button
        >
        <el-button v-if="showAgainAdd" type="success" @click="submitAndAdd">保存并添加</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>

    <!-- 项目选择弹窗 -->
    <el-dialog title="选择项目" width="80%" :visible.sync="dialogProject" :fullscreen="false">
      <XmList
        ref="xmList"
        :allowMultiple="false"
        :onlyFromAllowed="!hasTemporaryIds"
        :allowedXmIds="hasTemporaryIds ? [] : allowedXmIds"
        @confirm="handleProjectConfirm"
        @cancel="dialogProject = false"
      />
    </el-dialog>

    <!-- 发票选择弹窗 -->
    <el-dialog title="选择发票" width="90%" :visible.sync="dialogInvoice" :fullscreen="false">
      <FpList
        :key="invoiceDialogKey"
        ref="fpList"
        :selectedFpIds="allExcludedFpIds"
        :initialSelectedInvoices="[]"
        @confirm="handleInvoiceConfirm"
        @cancel="dialogInvoice = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import XmList from '@/fpComponents/XmList.vue';
import FpList from '@/fpComponents/FpList.vue';
import { bigDecimal as BigDecimal } from 'js-big-decimal';

export default {
  name: 'ClbxZsDialog',
  components: {
    XmList,
    FpList
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    ssxmCode: {
      type: String,
      default: ''
    },
    ssxmName: {
      type: String,
      default: ''
    },
    editData: {
      type: Object,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    // 新增：外部传入已选发票ID，用于在发票列表中过滤
    excludedFpIds: {
      type: Array,
      default: () => []
    },
    // 新增：允许选择的项目ID集合（仅从这些项目里单选）
    allowedXmIds: {
      type: Array,
      default: () => []
    },
    //市场部控制变量
    userType: {
      type: Boolean,
      default: false
    },
    // 新增：控制是否显示"再次添加"按钮
    showAgainAdd: {
      type: Boolean,
      default: true
    },
    // 新增：流程申请标识，用于区分删除接口
    flowApply: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      dialogProject: false,
      dialogInvoice: false, // 发票选择弹窗
      projectOptions: [],
      invoiceDialogKey: 0, // 用于强制刷新发票选择组件
      endDateOptions: {
        disabledDate: (time) => {
          if (this.form.startDate) {
            const startNum = this.toYmdNumber(this.form.startDate);
            const timeNum = this.toYmdNumber(time);
            if (startNum == null || timeNum == null) return false;
            return timeNum < startNum; // 允许同一天
          }
          return false;
        }
      },
      form: {
        ssxmCode: '',
        ssxmName: '',
        city: '', // 住宿城市
        zsTs: 1,
        zsAmt: 0,
        zsPrice: 0,
        remark: '',
        startDate: '',
        endDate: '',
        clbxId: '', // 住宿明细ID，编辑时使用
        _tempId: '', // 添加临时ID字段
        fpList: [] // 添加发票列表
      },
      rules: {
        ssxmCode: [{ required: true, message: '请选择所属项目', trigger: 'change' }],
        startDate: [{ required: true, message: '请选择开始日期', trigger: 'change' }],
        endDate: [
          { required: true, message: '请选择结束日期', trigger: 'change' },
          { validator: this.validateEndDate, trigger: 'change' }
        ],
        zsTs: [
          { validator: this.validateZsTs, trigger: 'change' },
          { validator: this.validateZsTs, trigger: 'blur' }
        ],
        city: [{ required: true, message: '请输入住宿城市', trigger: 'blur' }],
        zsPrice: [{ required: true, message: '请输入单价', trigger: 'blur' }],
        zsAmt: [{ required: true, message: '请输入住宿金额', trigger: 'blur' }],
        zsqk: [{ required: true, message: '请选择住宿情况', trigger: 'change' }]
      }
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.initForm();
      }
    },
    editData: {
      handler(val) {
        if (val) {
          this.initForm();
        }
      },
      deep: true
    },
    // 'form.startDate': function (val) {
    //   if (val && this.form.endDate) {
    //     this.calculateDays();
    //   }
    // },
    // 'form.endDate': function (val) {
    //   if (val && this.form.startDate) {
    //     this.calculateDays();
    //   }
    // },
    'form.fpList': {
      handler(val) {
        if (val && val.length > 0) {
          this.calculateTotalFromInvoices();
        }
      },
      deep: true
    }
  },
  computed: {
    // 计算属性：用于发票选择弹窗的排除ID，避免每次渲染都创建新数组
    allExcludedFpIds() {
      const excludedIds = [...(this.excludedFpIds || [])];
      if (this.form.fpList && this.form.fpList.length > 0) {
        this.form.fpList.forEach((fp) => {
          if (fp.fpId && !excludedIds.includes(fp.fpId)) {
            excludedIds.push(fp.fpId);
          }
        });
      }
      return excludedIds;
    },
    // 发票总金额
    fpTotalAmt() {
      if (!this.form.fpList || this.form.fpList.length === 0) {
        return 0;
      }
      let total = new BigDecimal('0');
      this.form.fpList.forEach((invoice) => {
        const amount = invoice.fpAmt || '0';
        total = total.add(new BigDecimal(String(amount)));
      });
      return total.getValue();
    },
    // 计算属性：检查是否有临时ID
    hasTemporaryIds() {
      return this.allowedXmIds.some((id) => id.toString().startsWith('temp_'));
    }
  },
  methods: {
    chengeDate() {
      if (this.form.startDate && this.form.endDate) {
        this.calculateDays();
      }
    },
    // 格式化开票日期
    formatKpDate(kpDate) {
      if (!kpDate) return '-';
      return dayjs(kpDate).format('YYYY-MM-DD');
    },
    getFileExtensionWithDot(filename) {
      if (!filename) return '';
      const lastDotIndex = filename.lastIndexOf('.');
      return lastDotIndex === -1 ? '' : filename.substring(lastDotIndex).toLowerCase();
    },
    initForm() {
      // 初始化表单数据
      if (this.editData) {
        // 编辑模式
        this.form = {
          ssxmCode: this.editData.ssxmCode || this.ssxmCode,
          ssxmName: this.editData.ssxmName || this.ssxmName,
          city: this.editData.city || '', // 住宿城市
          zsTs: this.editData.zsTs || 1,
          zsAmt: this.editData.zsAmt || 0,
          zsPrice: this.editData.zsPrice || 0,
          remark: this.editData.remark || '',
          startDate: this.editData.startDate || '',
          endDate: this.editData.endDate || '',
          clbxId: this.editData.clbxId || '',
          _tempId: this.editData._tempId || '', // 保留临时ID
          fpList: this.editData.fpList || [] // 保留发票列表
        };
      } else {
        // 新增模式
        this.form = {
          ssxmCode: this.ssxmCode,
          ssxmName: this.ssxmName,
          city: '', // 住宿城市
          zsTs: 1,
          zsAmt: 0,
          zsPrice: 0,
          remark: '',
          startDate: '',
          endDate: '',
          clbxId: '',
          _tempId: '', // 初始化临时ID为空
          fpList: [] // 初始化空发票列表
        };
      }
    },
    // 根据开始日期和结束日期计算天数
    calculateDays() {
      if (this.form.startDate && this.form.endDate) {
        const start = this.parseYmdToDate(this.form.startDate);
        const end = this.parseYmdToDate(this.form.endDate);
        if (!start || !end) return;
        const startNum = this.toYmdNumber(start);
        const endNum = this.toYmdNumber(end);
        if (endNum < startNum) {
          this.form.endDate = this.form.startDate;
          this.form.zsTs = 1;
          return;
        }
        const diffTime = end.getTime() - start.getTime();
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
        this.form.zsTs = diffDays;
        // 当已有住宿金额（来源于发票汇总等）时，按金额/天数自动计算单价
        if (this.form.zsAmt && this.form.zsTs && this.form.zsTs > 0) {
          const zsAmt = new BigDecimal(String(this.form.zsAmt));
          const zsTs = new BigDecimal(String(this.form.zsTs));
          this.form.zsPrice =
            zsAmt.divide(zsTs, 8).round(2, BigDecimal.RoundingModes.HALF_UP).getValue() * 1;
        }
      }
    },
    validateEndDate(rule, value, callback) {
      if (!value || !this.form.startDate) {
        callback();
        return;
      }
      const startNum = this.toYmdNumber(this.form.startDate);
      const endNum = this.toYmdNumber(value);
      if (startNum == null || endNum == null) {
        callback();
        return;
      }
      if (endNum < startNum) {
        callback(new Error('结束日期不能早于开始日期'));
      } else {
        callback();
      }
    },
    validateZsTs(rule, value, callback) {
      if (value === '' || value == null) {
        callback(new Error('请输入住宿天数'));
        return;
      }
      const num = Number(value);
      if (!Number.isFinite(num) || num <= 0) {
        callback(new Error('住宿天数必须大于0'));
        return;
      }
      if (!Number.isInteger(num)) {
        callback(new Error('住宿天数必须为整数'));
        return;
      }
      callback();
    },
    // 根据发票金额计算总金额
    calculateTotalFromInvoices() {
      if (this.form.fpList && this.form.fpList.length > 0) {
        let totalAmt = new BigDecimal('0');
        this.form.fpList.forEach((invoice) => {
          totalAmt = totalAmt.add(new BigDecimal(String(invoice.fpAmt || '0')));
        });
        this.form.zsAmt = totalAmt.getValue() * 1;
        // 如果已有天数，计算单价
        if (this.form.zsTs && this.form.zsTs > 0) {
          const zsAmt = new BigDecimal(String(this.form.zsAmt));
          const zsTs = new BigDecimal(String(this.form.zsTs));
          this.form.zsPrice =
            zsAmt.divide(zsTs, 8).round(2, BigDecimal.RoundingModes.HALF_UP).getValue() * 1;
        }
      }
    },
    handleClose() {
      this.$refs.form && this.$refs.form.resetFields();
      this.$emit('update:visible', false);
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 校验住宿金额不能大于发票总金额
          if (!this.validateZsAmt()) {
            return;
          }
          this.processSubmit(false);
        } else {
          return false;
        }
      });
    },
    // 保存并再次添加
    submitAndAdd() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 校验住宿金额不能大于发票总金额
          if (!this.validateZsAmt()) {
            return;
          }
          this.processSubmit(true);
        } else {
          return false;
        }
      });
    },

    // 处理提交
    processSubmit(addAgain = false) {
      const formData = { ...this.form };
      // 将天数和金额转为数字类型
      formData.zsTs = Number(formData.zsTs);
      formData.zsAmt = Number(formData.zsAmt);
      formData.zsPrice = Number(formData.zsPrice);
      // 保留临时ID，用于前端编辑跟踪
      if (this.editData && this.editData._tempId) {
        formData._tempId = this.editData._tempId;
      }
      this.$emit('submit', formData, addAgain);
      if (!addAgain) {
        this.handleClose();
      } else {
        // 如果是再次添加，重置表单但保留项目信息
        const ssxmCode = this.form.ssxmCode;
        const ssxmName = this.form.ssxmName;
        this.$refs.form.resetFields();
        this.initForm();
        this.form.ssxmCode = ssxmCode;
        this.form.ssxmName = ssxmName;
      }
    },
    // 显示项目选择弹窗
    showProjectDialog() {
      if (this.readonly) return;

      if (!Array.isArray(this.allowedXmIds) || this.allowedXmIds.length === 0) {
        // 如果没有限制且不是临时ID情况，则显示提示
        if (!this.hasTemporaryIds) {
          this.$message.warning('请先在申请信息中选择所属项目');
          return;
        }
      }
      // 检查是否有有效的项目ID（过滤掉null值）
      const validXmIds = this.allowedXmIds.filter((id) => id !== null && typeof id !== 'undefined');
      if (validXmIds.length === 0) {
        this.$message.warning('项目信息异常，请重新在申请信息中选择所属项目');
        return;
      }
      this.dialogProject = true;
    },
    // 处理项目选择确认
    handleProjectConfirm(selectedProjects) {
      if (selectedProjects && selectedProjects.length > 0) {
        const selectedProject = selectedProjects[0]; // 取第一个选中的项目
        this.form.ssxmCode = selectedProject.xmCode;
        this.form.ssxmName = selectedProject.xmName;
      }
      this.dialogProject = false;
    },

    // 显示发票选择弹窗
    showInvoiceDialog() {
      // 每次打开前刷新组件，确保最新的排除ID生效
      this.invoiceDialogKey += 1;
      this.dialogInvoice = true;
      this.$nextTick(() => {
        if (this.$refs.fpList) {
          // 清空内部选择列表
          this.$refs.fpList.selectList = [];
          // 清空表格选择状态（若组件内暴露了表格引用）
          if (
            this.$refs.fpList.$refs &&
            this.$refs.fpList.$refs.jhTable &&
            this.$refs.fpList.$refs.jhTable.clearSelection
          ) {
            this.$refs.fpList.$refs.jhTable.clearSelection();
          }
        }
      });
    },

    // 处理发票选择确认
    handleInvoiceConfirm(selectedInvoices) {
      if (selectedInvoices && selectedInvoices.length > 0) {
        // 映射发票数据字段，确保后端能正确接收
        const mappedInvoices = selectedInvoices.map((invoice) => ({
          fpId: invoice.fpid,
          fpNumber: invoice.fpNumber,
          fpAmt: invoice.amtSum,
          kpDate: invoice.kpRq,
          fpTypeName: invoice.fpTypeName,
          fpCatName: invoice.fpCatName,
          gfName: invoice.gfName,
          fpStatus: invoice.fpStatus,
          fileId: invoice.fileId,
          fpName: invoice.fpName,
          aliases: invoice.aliases,
          fpRemark: invoice.remark || invoice.bz || '' // 备注信息
        }));

        // 追加模式：将新选择的发票添加到当前已有的发票列表中
        const currentFpList = this.form.fpList || [];
        const existingFpIds = new Set(currentFpList.map((fp) => fp.fpId));
        const newInvoices = mappedInvoices.filter((invoice) => !existingFpIds.has(invoice.fpId));
        this.form.fpList = [...currentFpList, ...newInvoices];

        // 根据发票金额计算总金额
        this.calculateTotalFromInvoices();
      }
      this.dialogInvoice = false;
    },

    // 获取已选择的发票ID列表
    getSelectedFpIds() {
      if (!this.form.fpList || this.form.fpList.length === 0) {
        return [];
      }
      return this.form.fpList.map((fp) => fp.fpId);
    },
    // 删除发票
    removeInvoice(index) {
      this.$confirm('确定要删除这张发票吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const invoiceToRemove = this.form.fpList[index];

          // 如果是流程申请页面，需要调用后端删除接口
          if (this.flowApply && invoiceToRemove.fpId) {
            this.$api
              .formPost('/api/cwgl/clbx/flow/apply/zsFp/delete', {
                fpid: invoiceToRemove.fpId
              })
              .then((res) => {
                if (res.retHead && res.retHead.code === '0000000') {
                  console.log('住宿明细发票删除成功');
                } else {
                  console.error('住宿明细发票删除失败:', res.retHead?.message || '未知错误');
                }
              });
          }

          this.form.fpList.splice(index, 1);
          // 重新计算金额
          this.calculateTotalFromInvoices();
          this.$message.success('删除成功');
        })
        .catch(() => {
          // 用户取消删除
        });
    },

    // 预览发票
    previewInvoice(invoice) {
      if (!invoice.fileId) {
        this.$message.warning('发票文件ID不存在，无法预览');
        return;
      }
      console.log(invoice);

      // 获取行程单信息
      this.getXcdByFpIds([invoice.fpId])
        .then((xcdList) => {
          // 构建预览文件列表，包含发票和行程单
          const previewFiles = [];

          // 添加发票文件
          const invoiceFile = {
            label: invoice.aliases || '发票',
            id: invoice.fileId,
            url:
              this.getGlobalConfig().uploadURL +
              '/api/file/downloadFile' +
              '?fullfilename=' +
              invoice.fileId +
              this.getFileExtensionWithDot(invoice.aliases) +
              '&fileHashOrWholeFileId=' +
              invoice.fileId
          };
          previewFiles.push(invoiceFile);

          // 添加行程单文件
          if (xcdList && xcdList.length > 0) {
            xcdList.forEach((xcd, index) => {
              if (xcd.fileId) {
                previewFiles.push({
                  label: xcd.fileName || `行程单${index + 1}`,
                  id: xcd.fileId,
                  url:
                    this.getGlobalConfig().uploadURL +
                    '/api/file/downloadFile' +
                    '?fullfilename=' +
                    encodeURIComponent(xcd.fileName || '') +
                    '&fileHashOrWholeFileId=' +
                    xcd.fileId
                });
              }
            });
          }

          // 设置预览文件数据到 sessionStorage
          window.sessionStorage.previewFileData = JSON.stringify(previewFiles);

          // 左侧配置项 同elementUI tree组件
          window.sessionStorage.defaultProps = JSON.stringify({
            children: 'children',
            label: 'label'
          });

          // 当前高亮的文件（默认选中发票）
          window.sessionStorage.currentFile = invoice.fileId;

          // 打开预览页面
          window.open(
            window.location.origin +
              (window.location.pathname ? window.location.pathname : '') +
              '#/previewFile?timestamp=' +
              new Date().getTime()
          );
        })
        .catch((error) => {
          console.warn('获取行程单失败，仅预览发票:', error);
          // 如果获取行程单失败，仅预览发票
          const previewFile = {
            label: invoice.aliases || '发票',
            id: invoice.fileId,
            url:
              this.getGlobalConfig().uploadURL +
              '/api/file/downloadFile' +
              '?fullfilename=' +
              invoice.fileId +
              this.getFileExtensionWithDot(invoice.aliases) +
              '&fileHashOrWholeFileId=' +
              invoice.fileId
          };

          // 设置预览文件数据到 sessionStorage
          window.sessionStorage.previewFileData = JSON.stringify([previewFile]);

          // 左侧配置项 同elementUI tree组件
          window.sessionStorage.defaultProps = JSON.stringify({
            children: 'children',
            label: 'label'
          });

          // 当前高亮的文件
          window.sessionStorage.currentFile = invoice.fileId;

          // 打开预览页面
          window.open(
            window.location.origin +
              (window.location.pathname ? window.location.pathname : '') +
              '#/previewFile?timestamp=' +
              new Date().getTime()
          );
        });
    },
    // 预览所有发票
    previewAllInvoices() {
      if (!this.form.fpList || this.form.fpList.length === 0) {
        this.$message.warning('没有可预览的发票');
        return;
      }

      // 收集所有发票ID
      const allFpIds = this.form.fpList
        .filter((invoice) => invoice.fpId)
        .map((invoice) => invoice.fpId);

      if (allFpIds.length === 0) {
        this.$message.warning('没有有效的发票ID');
        return;
      }

      // 获取所有发票的行程单信息
      this.getXcdByFpIds(allFpIds).then((xcdList) => {
        // 构建所有发票和行程单的预览文件数据
        const previewFiles = [];

        // 添加所有发票文件
        this.form.fpList.forEach((invoice, index) => {
          if (invoice.fileId) {
            previewFiles.push({
              label: invoice.aliases,
              id: invoice.fileId,
              url:
                this.getGlobalConfig().uploadURL +
                '/api/file/downloadFile' +
                '?fullfilename=' +
                invoice.fileId +
                this.getFileExtensionWithDot(invoice.aliases) +
                '&fileHashOrWholeFileId=' +
                invoice.fileId
            });
          }
        });

        // 添加所有行程单文件
        if (xcdList && xcdList.length > 0) {
          xcdList.forEach((xcd, index) => {
            if (xcd.fileId) {
              previewFiles.push({
                label: xcd.fileName,
                id: xcd.fileId,
                url:
                  this.getGlobalConfig().uploadURL +
                  '/api/file/downloadFile' +
                  '?fullfilename=' +
                  xcd.fileId +
                  this.getFileExtensionWithDot(xcd.fileName) +
                  '&fileHashOrWholeFileId=' +
                  xcd.fileId
              });
            }
          });
        }

        if (previewFiles.length === 0) {
          this.$message.warning('没有可预览的文件');
          return;
        }

        // 设置预览文件数据到 sessionStorage
        window.sessionStorage.previewFileData = JSON.stringify(previewFiles);

        // 左侧配置项 同elementUI tree组件
        window.sessionStorage.defaultProps = JSON.stringify({
          children: 'children',
          label: 'label'
        });

        // 当前高亮的文件（默认选中第一个）
        window.sessionStorage.currentFile = previewFiles[0].id;

        // 打开预览页面
        window.open(
          window.location.origin +
            (window.location.pathname ? window.location.pathname : '') +
            '#/previewFile?timestamp=' +
            new Date().getTime()
        );
      });
    },

    // 根据发票ID获取行程单信息
    getXcdByFpIds(fpIds) {
      // 参数校验
      if (!fpIds || (Array.isArray(fpIds) && fpIds.length === 0)) {
        this.$message.warning('发票ID不能为空');
        return Promise.reject(new Error('发票ID不能为空'));
      }

      // 统一处理为数组格式
      const fpIdArray = Array.isArray(fpIds) ? fpIds : [fpIds];

      // 过滤掉空值
      const validFpIds = fpIdArray.filter((id) => id && id.toString().trim());

      if (validFpIds.length === 0) {
        this.$message.warning('没有有效的发票ID');
        return Promise.reject(new Error('没有有效的发票ID'));
      }

      const params = {
        fpIds: validFpIds
      };

      return this.$api
        .formPost('/api/major/fpgl/xcd/doGetByFpId', params)
        .then((res) => {
          if (res && res.retHead && res.retHead.code === '0000000') {
            return res.retBody || [];
          } else {
            const errorMsg = res?.retHead?.message || '获取行程单失败';
            console.error('获取行程单失败:', errorMsg);
            return Promise.reject(new Error(errorMsg));
          }
        })
        .catch((error) => {
          console.error('获取行程单请求失败:', error);
          return Promise.reject(error);
        });
    },
    handleZsTsChange(value) {
      const parsed = parseInt(value, 10);
      this.form.zsTs = Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
      if (this.form.zsAmt) {
        this.form.zsPrice = parseFloat((this.form.zsAmt / this.form.zsTs).toFixed(2));
      }
      this.$refs.form && this.$refs.form.validateField('zsTs');
    },
    handleZsAmtChange(value) {
      this.form.zsAmt = value;
      // 如果已有天数，计算单价
      if (this.form.zsTs && this.form.zsTs > 0) {
        const zsAmt = new BigDecimal(String(this.form.zsAmt));
        const zsTs = new BigDecimal(String(this.form.zsTs));
        this.form.zsPrice =
          zsAmt.divide(zsTs, 8).round(2, BigDecimal.RoundingModes.HALF_UP).getValue() * 1;
      }
    },
    handleZsPriceChange(value) {
      this.form.zsPrice = value;
    },
    toYmdNumber(input) {
      if (!input) return null;
      let y;
      let m;
      let d;
      if (input instanceof Date) {
        y = input.getFullYear();
        m = input.getMonth() + 1;
        d = input.getDate();
      } else {
        const parts = String(input)
          .split('-')
          .map((n) => parseInt(n, 10));
        if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return null;
        [y, m, d] = parts;
      }
      return y * 10000 + m * 100 + d;
    },
    parseYmdToDate(ymd) {
      if (!ymd) return null;
      const parts = String(ymd)
        .split('-')
        .map((n) => parseInt(n, 10));
      if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return null;
      const [year, month, day] = parts;
      return new Date(year, month - 1, day);
    },

    // 校验住宿金额不能大于发票总金额
    validateZsAmt() {
      const zsAmtValue = parseFloat(this.form.zsAmt || '0');
      const invoiceTotalValue = parseFloat(this.fpTotalAmt || '0');

      // 如果没有发票，不进行校验
      if (invoiceTotalValue === 0) {
        return true;
      }

      // 住宿金额不能大于发票总金额
      if (zsAmtValue > invoiceTotalValue) {
        this.$message.error(
          `住宿金额（${zsAmtValue.toFixed(2)}元）不能大于发票总金额（${invoiceTotalValue.toFixed(
            2
          )}元）`
        );
        return false;
      }

      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.el-input-number {
  width: 100%;
}
</style>
